import * as swcHelpers from '@swc/helpers';

function isFileRejection(error) {
    return 'file' in error;
}
const isUploadSuccess = (state)=>state.status === 'SUCCESS'
;
const isUploadError = (state)=>state.status === 'ERROR'
;
const isUploadIdle = (state)=>state.status === 'IDLE'
;
const isUploadIdleAfterFileRemove = (state)=>state.status === 'IDLE' && state.reason === 'FILE_REMOVED'
;
const isUploadLoading = (state)=>state.status === 'LOADING'
;
const uploadStatusSuccess = (uploadReference)=>({
        status: 'SUCCESS',
        uploadReference
    })
;
const uploadStatusError = (error, errorMessageId)=>({
        status: 'ERROR',
        error,
        errorMessageId
    })
;
const uploadStatusIdle = (reason)=>swcHelpers.objectSpread({
        status: 'IDLE'
    }, reason ? {
        reason
    } : {})
;
const uploadStatusLoading = ()=>({
        status: 'LOADING'
    })
;

export { isFileRejection, isUploadError, isUploadIdle, isUploadIdleAfterFileRemove, isUploadLoading, isUploadSuccess, uploadStatusError, uploadStatusIdle, uploadStatusLoading, uploadStatusSuccess };
//# sourceMappingURL=types.js.map
